var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticket-scanner" }, [
    _c("video", {
      ref: "video",
      staticClass: "ticket-scanner__video",
      attrs: { playsinline: "", muted: "", autoplay: "" },
      domProps: { muted: true },
    }),
    _c("canvas", { ref: "canvas", staticClass: "ticket-scanner__canvas" }),
    _c("div", { staticClass: "ticket-scanner__frame" }),
    _vm.paused
      ? _c("div", { staticClass: "ticket-scanner__paused" }, [
          _c("i", { staticClass: "feather icon-pause-circle" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }